//Generated File 
export const ACTIVE_ELEMENT = `activeEl`;
export const CALL_GUI_ACTION = `c$g$a`;
export const CHANGE_DIMENSIONS = `changeDimensions`;
export const COLUMN_IS_NOT_ENABLED = `@@Field is not enabled`;
export const COULD_NOT_FIND_COLUMN = `@@Could not find column `;
export const COULD_NOT_FIND_FIELD = `@@Could not find field `;
export const COULD_NOT_PERFORM_GRID_ACTION = `@@Could not perform grid action `;
export const ERRORS_SEP = `m$%$^**()kJ)(*`;
export const FETCH_ERRORS = `fetchErrors`;
export const FIELD_IS_NOT_ENABLED = `@@Field is not enabled`;
export const FIND_COLUMN_PAGE = `findColumnPage`;
export const FIND_FIELD_PAGE = `findFieldPage`;
export const HASH_CODE = `#code`;
export const HASH_ENTITY_TYPE = `#entityType`;
export const HASH_REFERENCE_NAME = `@name`;
export const HASH_TYPE = `#type`;
export const HASH_VALUE = `#value`;
export const INDICATORS = `indicators`;
export const INITIALIZING_PLACES = `initializingPlaces`;
export const MARK_DB_STATE = `getBizServerTime`;
export const NAMA_ACTIONS_PERFORMER = `namaActionsPerformer`;
export const NAMA_ADD_CRITERIA = `namaAddCriteria`;
export const NAMA_COLUMNS_SETTER = `namaColumnsSetter`;
export const NAMA_FIELDS_SETTER = `namaFieldsSetter`;
export const NAMA_GET_CURRENT_STATE = `namaGetCurrentState`;
export const NAMA_GET_STATE_OF_COLUMN = `namaGetStateOfColumn`;
export const NAMA_GET_STATE_OF_FIELD = `namaGetStateOfField`;
export const NAMA_GET_VALUE_OF_COLUMN = `namaGetValueOfColumn`;
export const NAMA_GET_VALUE_OF_FIELD = `namaGetValueOfField`;
export const NAMA_OPEN_LIST_WIDGET = `namaOpenListWidget`;
export const NAMA_OPEN_PAGE = `namaOpenPage`;
export const NAMA_PERFORM_GRID_ACTION = `namaPerformGridAction`;
export const NAMA_SET_ORDER_BY = `namaSetOrderBy`;
export const NEST_ACTIVE_COOKIE = `nestACtive`;
export const NO_ACTIVE_WINDOW = `@@No active window open`;
export const REVERT_TO_DB_STATE = `srIoMPsQRTorsd`;
export const SCHEDULED_TASKS_COUNT = `scheduledTasksCount`;
export const SERVER_TIME_STAMP = `bizServerTime`;
export const VALUES_SEP = `|`;
export const WAITING = `waiting`;
